import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

interface EmptyStateT {
  title: string;
  description?: string;
}

export const EmptyState = ({ title, description }: EmptyStateT) => {
  return (
    <Box p="space16" justifyContent="center">
      <Text textAlign="center" mb="space4" fontSize="400" color="text">
        {title}
      </Text>
      {description && (
        <Text fontSize="175" color="text">
          {description}
        </Text>
      )}
    </Box>
  );
};
